import request from '../index'

/**
 * 获取账号使用记录
 * @param {*} query
 * @returns
 */
export function getAccountUseRecord(query) {
    return request({
        url: '/box/account/useOrderList',
        method: 'get',
        params: query
    })
}

/**
 * 获取游戏账号密码
 * @param {*} data
 * @returns
 */
export function getAccountInfo(data) {
    return request({
        url: '/box/account/boxFamily/createOrder',
        method: 'post',
        data
    })
}

/**
 * 切换账号密码
 */
export function switchAccountInfo(data) {
    return request({
        url: '/box/account/change',
        method: 'post',
        data
    })
}

/**
 * 创建会员订单
 * @param {*} data
 * @returns
 */
export function createVipOrder(data) {
    return request({
        url: '/box/member/createOrder',
        method: 'post',
        data: { ...data, location: 'box' }
    })
}

/**
 * 获取会员订单列表
 * @param {*} query
 * @returns
 */
export function getVipOrder(query) {
    return request({
        url: '/box/member/orderList',
        method: 'get',
        params: query
    })
}

/**
 * 查询订单状态
 * @param {*} query
 * @returns
 */
export function queryOrderStatus(query) {
    return request({
        url: '/order/getOrderStatus',
        method: 'get',
        params: query,
        'axios-retry': {
            retries: 0
        }
    })
}

/**
 * 获取分组标签列表
 * @param {*} query
 * @returns
 */
export function queryTagGroup(query) {
    return request({
        url: '/game/game/tagGroup/list',
        method: 'post',
        params: query
    })
}

/**
 * 心跳接口释放账号
 * @param {*} query
 * @returns
 */
export function releaseAccount(query) {
    return request({
        url: '/box/member/heartbeat',
        method: 'get',
        params: query
    })
}

/**
 * 创建独享账号订单
 * @param {*} data
 * @returns
 */
export function createAloneOrder(data) {
    return request({
        url: '/shops/createCdkOrder',
        method: 'post',
        data
    })
}

/**
 * 查询独享账号订单状态
 * @param {*} query
 * @returns
 */
export function queryAloneOrderStatus(query) {
    return request({
        url: '/order/getOrderStatus',
        method: 'get',
        params: query,
        'axios-retry': {
            retries: 0
        }
    })
}

/**
 * 查询cdk类型的订单详情
 * @param {*} data
 * @returns
 */
export function queryCdkOrderDetail(data) {
    return request({
        url: '/shops/cdkOrderDetail',
        method: 'post',
        data
    })
}

/**
 * 获取购买的账号订单
 * @param {*} query
 * @returns
 */
export function getAccountOrder(query) {
    return request({
        url: '/order/orderAllList',
        method: 'get',
        params: query
    })
}
